import React from "react";
import Coupon from "./coupon";

import "./coupon.scss";
import { Trans } from "@lingui/react/macro";

export default class GenerateCoupon extends React.Component {
  render() {
    const { redeem_type, redeem_link, offer, store_info, program, language } = this.props;
    const usesRemaining = offer.number_of_uses_remaining;

    return usesRemaining === null || usesRemaining > 0 ? (
      <div className="coupon__container">
        <Coupon
          redeem_type={redeem_type}
          redeem_link={redeem_link}
          offer={offer}
          store_info={store_info}
          program={program}
          language={language}
        />
      </div>
    ) : (
      <div className="coupon__container no__coupon">
        <div className="coupon__redeem-content">
          <div>
            {offer.uses_per_period && (
              <span>
                <Trans>
                  This deal is limited to {offer.uses_per_period}. Uses remaining: {usesRemaining}.
                </Trans>
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}
